<template>
    <svg 
        role="presentation"
        class="svg-path svg-path--recruit" 
        :style="styles" :viewBox="viewBox"
    >
        <g class="path-line">
            <path class="path--fill" :d="pathsDash[1]"/>
            <path class="path--dash" :d="pathsDash[0]"/>
        </g>
        <g class="path-border">
            <path class="path--border" :d="pathsBorder[0]"/>
            <path class="path--border" :d="pathsBorder[1]"/>
        </g>
    </svg>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        styles: [Object, String],
    },

    watch: {
        isBrowserPortrait() {
            setTimeout(() => {
                if (!this.$parent.setupPath) return;
                const $p = this.$parent

                $p.setupPath()
                $p.pathProgress = $p.getProgress($p.pathStage)
            }, 16)
        },
    },

    computed: {
        ...mapGetters({
            isBrowserPortrait: 'browser/isTabletPortrait',
        }),
        svgWidth() {
            return this.isBrowserPortrait
                ? 834
                : 1920
        },
        viewBox() {
            return this.isBrowserPortrait
                ? '0 0 834 1194' 
                : '0 0 1920 1080'
        },
        pathsDash() {
            const landscape = [
                `M0.3,572l263.7-0.1c80.5,0,145.8,64.7,145.8,145.2l0,0v101.7c0,76,61.6,137.7,137.7,137.7l0,0
                c76,0,137.7-61.6,137.7-137.7l0,0V708.4c0-75.8,61.4-137.2,137.2-137.2l0,0c75.8,0,137.2,61.4,137.2,137.2l0,0v108.9
                c0,76,61.6,137.7,137.7,137.7l0,0h1c76,0,137.7-61.6,137.7-137.7V394.2c0-76,61.6-137.7,137.7-137.7l0,0
                c76,0,137.7,61.6,137.7,137.7l0,0v424.2c0,76,61.6,137.7,137.7,137.7l0,0h1c76,0,137.7-61.6,137.7-137.7l0,0V669
                c0-53.4,43.3-96.8,96.8-96.8h-0.8h35.9`,
                `M0.3,572l263.7-0.1c80.5,0,145.8,64.7,145.8,145.2l0,0v101.7c0,76,61.6,137.7,137.7,137.7l0,0
                c76,0,137.7-61.6,137.7-137.7l0,0V708.4c0-75.8,61.4-137.2,137.2-137.2l0,0c75.8,0,137.2,61.4,137.2,137.2l0,0v108.9
                c0,76,61.6,137.7,137.7,137.7l0,0h1c76,0,137.7-61.6,137.7-137.7V394.2c0-76,61.6-137.7,137.7-137.7l0,0
                c76,0,137.7,61.6,137.7,137.7l0,0v424.2c0,76,61.6,137.7,137.7,137.7l0,0h1c76,0,137.7-61.6,137.7-137.7l0,0V669
                c0-53.4,43.3-96.8,96.8-96.8h-0.8h35.9`
            ]
            const portrait = [
                `M-19.7,586.46H622.38c52.16,0,94.44,42.58,94.44,95.09h0c0,52.52-42.28,95.09-105.44,96.09H199c-44.1-1-88.77,44-88.77,99.45h0c0,55.47,44.67,100.44,99.77,100.44h627.5`,
                `M-19.7,586.46H622.38c52.16,0,94.44,42.58,94.44,95.09h0c0,52.52-42.28,95.09-105.44,96.09H199c-44.1-1-88.77,44-88.77,99.45h0c0,55.47,44.67,100.44,99.77,100.44h627.5`
            ]
            return this.isBrowserPortrait ? portrait : landscape
        },
        pathsBorder() {
            const landscape = [
                `M1920.4,585.7h-36.2c-45.7,0.1-82.7,37.1-82.8,82.8v149.3c0,83.6-68,151.7-151.7,151.7h-1
                c-83.6,0-151.7-68-151.7-151.7V394.2c0.6-68.3-54.3-124.2-122.6-124.8c-68.3-0.6-124.2,54.3-124.8,122.6c0,0.7,0,1.5,0,2.2v422.7
                c0,83.6-68,151.7-151.7,151.7h-1c-83.6,0-151.7-68-151.7-151.7V708c0-68-55.1-123.2-123.2-123.2S698.8,639.9,698.8,708v110.9
                c0,83.6-68,151.7-151.7,151.7s-151.7-68-151.7-151.7V716.6c0-72.7-59.1-130.8-131.7-130.8H-0.8`,
                `M-0.3,557.7H264c88.1,0,159.7,70.7,159.7,158.8v102.2c0.6,68.3,56.5,123.2,124.8,122.6
                c67.4-0.6,122-55.1,122.6-122.6V707.8c0-83.4,67.8-151.2,151.2-151.2s151.2,67.8,151.2,151.2v108.9
                c0.1,68.3,55.4,123.6,123.6,123.7h1c68.3-0.1,123.6-55.4,123.7-123.7V394.2c0-83.6,68-151.7,151.7-151.7s151.7,68,151.7,151.7
                v423.7c0.1,68.3,55.4,123.6,123.7,123.7h1c68.3-0.1,123.6-55.4,123.7-123.7V668.5c0.1-61.1,49.6-110.7,110.8-110.8h36.6`
            ]
            const portrait = [
                `M-5.63,575.18H622.21c58.42,0,105.94,47.81,105.94,106.58S680.63,788.35,611.21,789.35H198.86c-37.67-1-77.26,38.9-77.26,87.95s39.59,88.94,88.26,88.94H835`,
                `M835,989.24H209.86C148.51,989.24,98.6,939,98.6,877.3s49.91-111.95,100.26-110.95H611.21c56.73-1,93.94-38.5,93.94-84.59s-37.21-83.58-82.94-83.58H-5.63`
            ]
            return this.isBrowserPortrait ? portrait : landscape
        },
    },
}
</script>